<template>
  <div data-masonry-columns-cell class="MASONRY-COLUMNS-CELL">
    <div data-masonry-columns-cell-content :class="{ 'BORDER': bordered }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'masonry-columns-cell',
  props: {
    bordered: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .MASONRY-COLUMNS-CELL:not(:first-of-type) {
    .BORDER {
      padding-top: 2*$unit;
      border-top: 1px solid $color-gray30;
    }
  }
</style>
